import React, { useEffect, useState } from "react";
import { men } from "../../data/user-dashboard";
import { Helmet } from "react-helmet-async";
import api from "../../utilis/api";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const Myorder = () => {
  const [orders, setOrders] = useState([]);
  const token = useSelector((state) => state.user.token) || "";
  const navigate = useNavigate();
  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const response = await api.get("/orders/orders", {
          headers: { authorization: `Bearer ${token}` },
        });

        setOrders(response.data.data.orders);
      } catch (err) {
        console.error(err.response?.data || err);
      }
    };

    if (token) fetchOrders();
  }, [token]);

  return (
    <>
      <Helmet>
        <title>My Orders</title>
        <meta name="description" content="Welcome to My Orders page" />
      </Helmet>

      <div className="w-full px-[0.5rem] sm:px-[2rem]">
        <h1 className="text-center font-bold text-[1.6rem] sm:text-[1.7rem] md:text-[1.8rem]">
          My Orders
        </h1>

        <div className="w-[100%] sm:w-full flex flex-col gap-[1rem] mt-[2rem]">
          {orders && orders.length > 0 ? (
            orders.map((order) => (
              <div
                key={order._id}
                className="w-[100%] sm:w-full flex justify-between items-center px-[0.5rem] sm:px-[1.5rem] py-[1.5rem] shadow-[0_3px_8px_rgba(0,0,0,0.24)]"
              >
                <div className="flex flex-col">
                  <h1 className="font-semibold text-[1.1rem]">
                    Order ID: {order.orderNo}
                  </h1>

                  <p className="text-gray-500 text-[0.9rem]">
                    Total: ${order.totalPrice}
                  </p>

                  <p className="text-gray-500 text-[0.9rem]">
                    Shipping: {order.shippingMethod}
                  </p>

                  <p className="text-gray-500 text-[0.9rem]">
                    Payment Status: {order.paymentStatus}
                  </p>
                  <p className="text-gray-500 text-[0.9rem]">
                    User Name: {order.user.name}
                  </p>
                </div>

                <button
                  onClick={() => navigate(`/user/order_detail/${order._id}`)}
                  className="bg-black text-[10px] sm:text-[14px] text-white px-2 sm:px-8 py-2 rounded-lg hover:bg-gray-800"
                >
                  Order Details
                </button>
              </div>
            ))
          ) : (
            <div className="mt-[2rem]">
              <p className="w-full text-center text-blue-800 bg-blue-100 border border-blue-400 rounded-md py-3 px-4 text-sm font-medium shadow-md">
                No orders found.
              </p>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Myorder;
